export default {
  "content": "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" stroke=\"#00809D\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M24 34c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z\" clip-rule=\"evenodd\"/><path stroke=\"#00809D\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M22 27v-6m4 6v-6\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48",
    "fill": "none",
    "viewBox": "0 0 48 48"
  }
};